import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    // You can also log errors to an error reporting service here
    // logErrorToMyService(error, errorInfo);
  }


  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return typeof this.props.fallback === 'function' 
        ? this.props.fallback(this.state.error)
        : this.props.fallback || (
            <div className="p-4 bg-red-50 text-red-700 rounded">
              <h3 className="font-bold">Something went wrong.</h3>
              <p className="text-sm mt-1">
                {this.state.error?.message || 'An unexpected error occurred.'}
              </p>
            </div>
          );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),
};

export default ErrorBoundary;
